import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';
import { MVMSpinnerBtnModule } from '../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { CustomerCharacteristicModalComponent } from './customer-characteristic-modal.component';
import { CustomerCharacteristicComponent } from './customer-characteristic.component';

@NgModule({
    declarations: [
        CustomerCharacteristicComponent,
        CustomerCharacteristicModalComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        CommonModule,
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        SharedPipesModule,
        TableModule,
        ValidationResultsModule
    ],
    exports: [
        CustomerCharacteristicComponent,
        CustomerCharacteristicModalComponent
    ]
})

export class CustomerCharacteristicModule {}
